import BaseService from "@/js/core/BaseService";
import { BenefitEndpoints } from "./BenefitEndpoints";

export default class BenefitService extends BaseService {
  async fetchBenefits() {
    return this.api().get(BenefitEndpoints.FetchBenefits);
  }
}
